'use client';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useSessionGuardStore } from '@/stores/sessionGuardStore';

export function DisconnectOverlay() {
  const t = useTranslations('sessionGuard');
  const blockState = useSessionGuardStore((s) => s.blockState);
  if (blockState !== 'hard') return null;
  return (
    <div
      role="alertdialog"
      aria-live="assertive"
      className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm"
    >
      <div className="rounded-lg border bg-surface p-6 shadow-lg max-w-sm text-center space-y-3">
        <Loader2 className="h-6 w-6 animate-spin text-accent mx-auto" />
        <h2 className="font-serif text-lg font-medium leading-tight">
          {t('disconnectOverlay.reconnecting')}
        </h2>
        <p className="text-sm text-muted-foreground">
          {t('disconnectOverlay.signedOutWarning')}
        </p>
      </div>
    </div>
  );
}
